import { Heading, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { WellLevelNote } from "../../../types/wellLevelNotes";

export function WellLevelNotes({ wellLevelNotes }: { wellLevelNotes: WellLevelNote[] }) {
  if (wellLevelNotes.length === 0) return <></>;
  return (
    <div>
      <Heading size="md">Notes:</Heading>

      <TableContainer whiteSpace={"normal"}>
        <Table variant="striped" size="sm" colorScheme="darkBrown">
          <Thead>
            <Tr>
              <Th>Note</Th>
              <Th>Start Date</Th>
              <Th>End Date</Th>
            </Tr>
          </Thead>
          <Tbody>
            {wellLevelNotes.map((note) => (
              <Tr key={note.note}>
                <Td whiteSpace={"normal"}>{note.note}</Td>
                <Td>{note.startDate.toLocaleString()}</Td>
                <Td>{note.endDate.toLocaleString()}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
}
